require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-stoob.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-stoob");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-stoob!./.cache/json/betreuungseinrichtungen-oberpullendorf-stoob.json
// module id = 994
// module chunks = 231608221292675